import { useEffect, useState } from "react";

import GeneratedRecord, { GeneratedRecordItem } from "../../models/generated-record";
import { useHistory, useParams } from "react-router-dom";
import { getItem, getList } from "../../api/generics";
import { SUCCESS } from "../../utils/constants/tags";
import { warningAlert } from "../utils/messages";
import Loading from "../../pages/Loading";

import RecordDetailMainData from "./RecordDetailMainData";
import RecordDetailItemData from "./RecordDetailItemData";
import { CCol, CContainer, CLink, CRow } from "@coreui/react";

const ITEMS_PER_PAGE = 20

const CustomsPage = () => {
  const [record, setRecord] = useState<GeneratedRecord | undefined>(undefined);
  const [recordItems, setRecordItems] = useState<GeneratedRecordItem[]>([]);
  const [selectedItem, setSelectedItem] = useState<GeneratedRecordItem | undefined>(undefined);
  const [loading, setLoading] = useState(true);
  const [sidebarColor, setSidebarColor] = useState("#222d32");
  const [sidebarWidth, setSidebarWidth] = useState("54px");
  const [showHeaderRight, setShowHeaderRight] = useState(true);

  const [totalPages, setTotalPages] = useState(1);
  const [currentPage, setCurrentPage] = useState(1);

  const [search, setSearch] = useState<string>("");
  const { id } = useParams<{ id: string }>();
  const history = useHistory();

  const getInitialValues = async () => {
    setLoading(true);
    const recordPromise = fetchRecord(id);
    await recordPromise;
    const recordItemsPromise = fetchRecordItems(id, 1);
    await recordItemsPromise;
    setLoading(false);
  };

  const fetchRecord = async (id: string) => {
    const recordStatus = await getItem<GeneratedRecord>(`/records/${id}/`);
    if (recordStatus.status === SUCCESS) {
      if (recordStatus.data !== undefined) {
        setRecord(recordStatus.data);
      }
    } else {
      const message = recordStatus.detail
        ? recordStatus.detail
        : "Error desconocido";
      warningAlert(message);
    }
  };

  const fetchRecordItems = async (id: string, page:number) => {
    const limit = ITEMS_PER_PAGE;
    const offset = ITEMS_PER_PAGE * (page-1);
    let additionalParams: Map<string, string> | undefined = new Map<string, string>();
    additionalParams.set("record_id", id);
    const recordItemsStatus = await getList<GeneratedRecordItem>(
      `/record_items/`,
      limit,
      offset,
      additionalParams
    );
    if (recordItemsStatus.status === SUCCESS) {
      if (recordItemsStatus.data !== undefined) {
        const count = recordItemsStatus.data.count;
        const pages = Math.ceil((count ? count : 0) / ITEMS_PER_PAGE);
        setTotalPages(pages);
        if (currentPage>pages){
          setCurrentPage(pages)
        }
        setRecordItems(recordItemsStatus.data.items);
      }
    } else {
      const message = recordItemsStatus.detail
        ? recordItemsStatus.detail
        : "Error desconocido";
      warningAlert(message);
    }
  };

  const onItemClick = (recordItem: GeneratedRecordItem) => {
    setSelectedItem(recordItem);
  };

  const onGoBackItemClick = () => {
    setSelectedItem(undefined);
  };

  const onSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearch(e.target.value);
  };

  const onSearch = () => {
    if (search.trim() !== "") {
      setLoading(true);
      setTimeout(() => {
        history.push(`/search/${search.trim()}`);
        setLoading(false);
      }, 500);
    }
  };

  const handleKeyDown = (event: React.KeyboardEvent) => {
    if (event.key === "Enter") {
      onSearch();
    }
  };

  const onPageChange = (page: number) => {
    setCurrentPage(page)
    fetchRecordItems(id, page)
  };

  const onRecordDetailClick = () => {
    setLoading(true);
      setTimeout(() => {
        history.push(`/records/${id}`);
        setLoading(false);
      }, 200);
  
  };

  useEffect(() => {
    if (id === undefined) {
      setLoading(false);
      return;
    }
    getInitialValues();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth <= 768){
        setSidebarColor("#ffffff");
        setSidebarWidth("0");
        setShowHeaderRight(false);
      } else {
        setSidebarColor("#222d32");
        setSidebarWidth("54px")
        setShowHeaderRight(true);
      }
    };

    handleResize(); 
    window.addEventListener("resize", handleResize); 

    return () => window.removeEventListener("resize", handleResize); 
  }, []);

  if (loading) {
    return <Loading />;
  }

  return (
    <div style={{ fontFamily: "Myanmar Text, sans-serif", backgroundColor: "#ffffff", height: "100vh", display: "flex", flexDirection: "column" }}>
      <header
    style={{
      backgroundColor: "#004080",
      color: "white",
      height: "60px",
      width: "100%",
      padding: "0 20px",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
    }}
  >
    <div>
      <img
        src="/dnalogo2022.png"
        alt="Logo"
        style={{ height: "50px", marginRight: "10px" }}
      />
    </div>

    
    {showHeaderRight?<div
      style={{
        position: "relative",
        flex: 1,
        marginLeft: "auto",
        marginRight: "20px",
        maxWidth: "300px",
      }}
    >
      <input
        type="text"
        placeholder="Buscar..."
        style={{
          padding: "5px 30px 5px 10px",
          borderRadius: "5px",
          border: "1px solid white",
          backgroundColor: "#004080",
          color: "white",
          width: "100%",
        }}
        onKeyDown={handleKeyDown}
        onChange={onSearchChange}
        value={search}
      />
      <i
        className="fas fa-search"
        style={{
          position: "absolute",
          right: "10px",
          top: "50%",
          transform: "translateY(-50%)",
          color: "white",
        }}
        onClick={onSearch}
      ></i>
    </div>:<div></div>}

    <div>
      <span style={{ marginRight: "10px" }}>ANÓNIMO</span>
      <i className="fas fa-chevron-down"></i>
    </div>
  </header>

      <div>
        
        
        <aside
          style={{
            width: sidebarWidth,
            backgroundColor: sidebarColor,
            position: "fixed",
            top: "60px", 
            bottom: "0",
          }}
        ></aside>

        <main 
          style={{
            marginLeft: sidebarWidth,
            marginTop: "20px",
            backgroundColor: "#ffffff",
            flexGrow: 1,
            display:"flex",
          }}
        >
          <CContainer style={{
              width: "100%", 
              margin: "0 auto",
            }}>
            <CRow>
              <CCol>
                <CRow>
                  <CCol lg={1}>
                    <img
                        src="/Warning32x32.png"
                        alt="Logo"
                        style={{ height: "32px", marginRight: "10px" }}
                    />
                  </CCol>
                  <CCol lg={10}>
                    <CRow><CCol><strong style={{ color: "#004080", fontSize:"larger" }}>Existen versiones posteriores al DUA consultado</strong></CCol></CRow>
                    <CRow><CCol><CLink
                      href={`#`}
                      target="_blank"
                      style={{textDecoration:"underline"}}
                      onClick={() => onRecordDetailClick()}
                    >
                      {`Ver ${record?.identifier? record.identifier:"DUA"}`}
                    </CLink></CCol></CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CContainer>
        </main>
      </div>
    </div>
  );
};

export default CustomsPage;
